import styled, { ITheme } from '../../../theme'

const Label = styled.div`
  margin: 30px 0px;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${(props: ITheme) => props.theme.colors.palette.darkGreyTwo};
`

export default Label
